const millisecondsPerDay = 24 * 60 * 60 * 1000;

const getRemainingDays = (date) => {
  const currentDate = new Date();
  const endDate = new Date(date);

  let days = Math.ceil((endDate - currentDate) / millisecondsPerDay);

  if ((endDate - currentDate) * -1 < millisecondsPerDay && days === 0) {
    days = 1;
  } else {
    days += 1;
  }

  return days;
};

export default getRemainingDays;
